import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Table as TablePDF } from "@david.kucsai/react-pdf-table/lib/Table";
import { TableHeader as TableHeaderPDF } from "@david.kucsai/react-pdf-table/lib/TableHeader";
import { TableCell as TableCellPDF } from "@david.kucsai/react-pdf-table/lib/TableCell";
import { TableBody as TableBodyPDF } from "@david.kucsai/react-pdf-table/lib/TableBody";
import { DataTableCell } from "@david.kucsai/react-pdf-table";
import GetCurrency from "../../helper/GetCurrency";

export default function ViewTurnover(props) {
  let total = 0;

  let data = Object.keys(props.totalTurnover).map((vat) => {
    total += props.totalTurnover[vat];
    return {
      vatKey: vat,
      vat: vat * 100.0 + " %",
      turnover: GetCurrency() + ((props.totalTurnover[vat] + Number.EPSILON) / 100.0).toFixed(2),
    };
  });

  const getPdfView = () => {
    return (
      <TablePDF data={data}>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Omzet (Exc. BTW)</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Bedrag
          </TableCellPDF>
        </TableHeaderPDF>
        <TableBodyPDF>
          <DataTableCell weighting={0.3} getContent={(r) => r.vat} />
          <DataTableCell weighting={0.3} align={"right"} getContent={(r) => r.turnover} />
        </TableBodyPDF>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Totaal</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {((total + Number.EPSILON) / 100.0).toFixed(2)}
          </TableCellPDF>
        </TableHeaderPDF>
      </TablePDF>
    );
  };

  props.createPdf(getPdfView());

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Omzet (Exc. BTW)</TableCell>
            <TableCell align={"right"}>Bedrag</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((r) => {
            return (
              <TableRow key={r.vatKey}>
                <TableCell>{r.vat}</TableCell>
                <TableCell align={"right"}>{r.turnover}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell>Totaal</TableCell>
            <TableCell align={"right"}>{((total + Number.EPSILON) / 100.0).toFixed(2)}</TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
